export default __webpack_public_path__ + "static/media/business-item-6.a11545fa.png";